/**
 * Ajax Zip
 */
const ajaxZip = () => {
  const zip = document.querySelector('.js-zip');

  if (zip) {
    zip.addEventListener('click', ()=> {
      // @ts-ignore
      AjaxZip3.zip2addr('post-code', '', 'address', 'address');    
    });
  }
};

export default ajaxZip;